// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"172":"b17a0605","508":"8145d95c","901":"f4fee7a3"}[chunkId] + ".css";
};